import React from "react";
import UnForm from "../../../../../Components/Form";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { CancelarCasoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ICancelarCaso } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { ListartMotivoCancelamentoController } from "../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoController";

interface IJustificativaCancelamentoCancelarCaso {
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    execute: (
        ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
    ) => Promise<void>;
    ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number;
}

export default function JustificativaCancelamentoCancelarCaso(
    props: IJustificativaCancelamentoCancelarCaso
) {
    // eslint-disable-next-line
    const { idModulo, ID_CASO, Atendimento, updateAtendimento } =
        useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    /*
        A rota usada pela controller ListarJustificativaCancelamentoController
        foi substituida pela ListartMotivoCancelamentoController, por conta de 
        um problema conceitual que existe na tela de cadastro de Motivo Cancelamento, 
        que deve ser criada em um melhoria posteriormente, para entender melhor o 
        contexto dessa alteração verifique o atendimento 33831
    */
    const { execute: ListarJustificativaCancelamento } = useAsyncEffect(
        // () => ListarJustificativaCancelamentoController(idModulo),
        () => ListartMotivoCancelamentoController(),
        []
    );

    const { execute: CancelarCaso, loading: cancelarCasoLoading } =
        useAsyncCallback(CancelarCasoController);

    function handleJustificativaCancelamentoCancelarCaso(
        formData: ICancelarCaso
    ) {
        CancelarCaso({
            ...formData,
            Justificativa: formData.Justificativa,
            ID_CASO_MOTIVO_CANCELAMENTO: Number(
                formData.ID_CASO_MOTIVO_CANCELAMENTO
            ),
            ID_CASO: ID_CASO,
            ID_ETAPA_TIPO_CASO: Atendimento?.ID_ETAPA_TIPO_CASO,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        }).then(() => {
            props.setShow(false);
            updateAtendimento();
            ReloadHistorico();
        });
    }

    return (
        <>
            <UnForm handleSubmit={handleJustificativaCancelamentoCancelarCaso}>
                <UnForm.LazySelect
                    name="ID_MOTIVO_CANCELAMENTO"
                    label="Motivo Cancelamento"
                    controller={ListarJustificativaCancelamento}
                    getDS={(ds) => ds.DS_MOTIVO_CANCELAMENTO}
                    getKeyValue={(key) => key.ID_MOTIVO_CANCELAMENTO}
                >
                    <option></option>
                </UnForm.LazySelect>
                <UnForm.Textarea
                    label="Justificativa"
                    name="Justificativa"
                    registerOptions={{ required: "Insira uma justificativa" }}
                />
                <UnForm.SubmitButton
                    loading={cancelarCasoLoading}
                    wrapperClassName="d-flex col-12 justify-content-end mt-3 mr-0 p-0"
                    disabled={cancelarCasoLoading}
                    className="col-12"
                    icon={faPaperPlane}
                    color="primary"
                    loadingSize="sm"
                >
                    Cancelar Solicitação
                </UnForm.SubmitButton>
            </UnForm>
        </>
    );
}
